module.exports = __webpack_public_path__ + "img/metamask.f3f9985d.png";